/**
. a dedicated class for doing animations
* */
import Browser from '../hooks/Browser';
import getFixedTop from '../hooks/getFixedTop';
import getViewport from '../hooks/getViewport';
import { Position } from '../enums/Enum';
import WidgetTypes from '../enums/WidgetTypes';
/**
 * 
 * @param {*} me.configurations 
 * @param {*} dom  optional document object to cater parent and iframe based DOM manipulation alike 
  @returns 
 */

export default class Animator {
    constructor(configurations, dom) {
        this.configuration = configurations;
        this.$el = this.configuration.el;
        this.DOM = dom || document;
        this.attr = 'bottom';
    }

    tabMaximize(options) {
        const me = this;
        const chatTabPosition = me.configuration.chatTab.chatTabLeftSide ? 'left' : 'right'; // We need in string that Tab is left or Right
        // summary: Due to RESET CSS the animation was not working because earlier version was using IN-Line CSS and now recently chat_tab.css was introduced so Sliding animation can only play via JS version
        let marginValue = parseFloat(me.configuration.chatTab.borderWidth) + 10;
        if (!me.configuration.chatTab.chatTabLeftSide) {
            marginValue += 5;
        }
        ApexChat.animate(
            document.getElementById(options.element),
            `top: 50%;${chatTabPosition}: -150px; margin-${chatTabPosition}: ${marginValue}px;`,
            {
                duration: 110,
                after() {
                    ApexChat.animate(
                        document.getElementById(options.element),
                        `${chatTabPosition}: 0px; margin-${chatTabPosition}: ${marginValue}px;`,
                        {
                            duration: 500
                        }
                    );
                }
            }
        );
    }

    tabMinimize(options) {
        const me = this;
        const chatTabPosition = me.configuration.chatTab.chatTabLeftSide ? 'left' : 'right'; // We need in string that Tab is left or Right
        const marginValue = `${parseFloat(me.configuration.chatTab.borderWidth) + 18}px`;
        ApexChat.animate(
            document.getElementById(options.element),
            `${chatTabPosition}: -150px; margin-${chatTabPosition}: -50px;top: 44%;`,
            {
                duration: 110,
                after() {
                    ApexChat.animate(
                        document.getElementById(options.element),
                        `${chatTabPosition}: 0px; margin-${chatTabPosition}: ${marginValue};`,
                        {
                            duration: 500
                        }
                    );
                }
            }
        );
    }

    slide(options, configuration, position) {
        const me = this;
        const pureElement = me.getPureElement(options.element);
        const ele = me.getElement(options.element, pureElement);
        const target = ele.offsetHeight;
        this.invitationHeight = target; // Store the height so we can still use it in height calculations if the tab is animating
        // set it at the right position, but with a 0px height
        ele.style[me.attr] = me.getEndPosition(position, ele);
        ele.style.height = '0px';
        this.initialDisplayAnimation = ApexChat.animate(pureElement, `height:${target}px`, {
            duration: me.configuration.animationTime,
            after() { }
        });
    }

    slideFromLeft(options, configuration, position) {
        const me = this;
        const pureElement = me.getPureElement(options.element);
        const ele = me.getElement(options.element, pureElement);
        let dims = getViewport();
        let start = `${dims[1]}px`;
        let end = me.getEndPosition(position, ele);
        // for IE, we deal with the top of the invitation
        if (Browser.isIE()) {
            me.attr = 'top';
            start = '0px';
            end = getFixedTop(position, ele);
        }
        // set it at the right position, but with a 0px height
        ele.style[me.attr] = end;
        dims = getViewport();
        let endinglocation = '';
        switch (position) {
            case Position.Right:
            case Position.TopRight:
                delete ele.style.left;
                ele.style.right = `${dims[0]}px`;
                endinglocation = 'right:0px';
                break;
            case Position.Left:
            case Position.TopLeft:
                ele.style.left = `${-ele.offsetWidth}px`;
                endinglocation = 'left:0px';
                break;
            case Position.Center:
            case Position.Middle:
            case Position.TopMiddle:
                ele.style.left = '0px';
                var left = `${dims[0] / 2 - ele.offsetWidth / 2}px`;
                endinglocation = `left:${left}`;
                break;
            default:
        }
        this.initialDisplayAnimation = ApexChat.animate(pureElement, endinglocation, {
            duration: me.configuration.animationTime,
            after() { }
        });
    }

    slideFromRight(options, configuration, position) {
        const me = this;
        const pureElement = me.getPureElement(options.element);
        const ele = me.getElement(options.element, pureElement);
        ele.style[me.attr] = me.getEndPosition(position, ele);
        const dims = getViewport();
        let endinglocation = '';
        switch (position) {
            case Position.Right:
            case Position.TopRight:
                ele.style.right = `${-ele.offsetWidth}px`;
                endinglocation = 'right:0px';
                break;
            case Position.Left:
            case Position.TopLeft:
                ele.style.left = `${dims[0]}px`;
                endinglocation = 'left:0px';
                break;
            case Position.Center:
            case Position.Middle:
            case Position.TopMiddle:
                ele.style.left = `${dims[0]}px`;
                var left = `${dims[0] / 2 - ele.offsetWidth / 2}px`;
                endinglocation = `left:${left}`;
                break;
            default:
        }
        this.initialDisplayAnimation = ApexChat.animate(pureElement, endinglocation, {
            duration: me.configuration.animationTime,
            after() { }
        });
    }

    slideDrop(options, configuration, position) {
        // const me = this;
        // const pureElement = me.getPureElement(options.element);
        // const ele = me.getElement(options.element, pureElement);
        // const dims = getViewport();
        // const start = `${dims[1]}px`;
        // let end = me.getEndPosition(position, ele);
        // if (
        //     !(
        //         position == Position.TopLeft ||
        //         position == Position.TopMiddle ||
        //         position == Position.TopRight
        //     )
        // ) {
        //     end = `${me.attr}:${end}`;
        //     ele.style[me.attr] = start;
        // }
        // this.initialDisplayAnimation = ApexChat.animate(pureElement, end, {
        //     duration: me.configuration.animationTime,
        //     // bounce function, from emile.js
        //     easing: me.bounce,
        //     after() { }
        // });
    }

    getPureElement(element) {
        if (element.indexOf('.') === -1 && element.indexOf('#') === -1) {
            return element;
        }
        return element.substring(1, element.lenght);
    }

    getElement(element, pureElement) {
        const me = this;
        return me.isClass(element)
            ? document.getElementsByClassName(pureElement)[0]
            : document.getElementById(pureElement);
    }

    isClass(element) {
        return element.indexOf('.') !== -1;
    }

    getEndPosition(position, element) {
        const dims = getViewport();
        const halfHeight = dims[1] / 2 - element.offsetHeight / 2;
        return position == Position.Center ||
            position == Position.LeftCenter ||
            position == Position.RightCenter
            ? `${halfHeight}px`
            : '0px';
    }

    bounce(pos) {
        if (pos < 1 / 2.75) {
            return 7.5625 * pos * pos;
        }
        if (pos < 2 / 2.75) {
            return 7.5625 * (pos -= 1.5 / 2.75) * pos + 0.75;
        }
        if (pos < 2.5 / 2.75) {
            return 7.5625 * (pos -= 2.25 / 2.75) * pos + 0.9375;
        }
        return 7.5625 * (pos -= 2.625 / 2.75) * pos + 0.984375;
    }

    wiggleElement(options) {
        const me = this;
        const wiggleBounceAnimationDuration = 1000;
        const pureElement = me.getPureElement(options.element);
        const ele = me.getElement(options.element, pureElement);
        const { position } = options;
        const end = me.getEndPosition(position, ele);
        const bottom = parseInt(ele.style.bottom === '' ? 0 : ele.style.bottom);
        // JIRA_4452 - Emile.js error
        // summary: we need to wiggle the widget if its only bottom (as V3 on top position wiggle is not required) as per V2.
        if (
            !(
                position == Position.TopLeft ||
                position == Position.TopMiddle ||
                position == Position.TopRight
            )
        ) {
            const amount = parseInt(bottom, 10) + 25;
            const easing = me.bounce;
            const targetCSS = `${me.attr}:${amount}px`;
            const backToOldCSS = `${me.attr}:${end}`;
            ApexChat.animate(pureElement, targetCSS, {
                duration: wiggleBounceAnimationDuration, // This animation shouldn't be set from the profile me.configuration. This is the bounce back duration of the wiggle widget.
                after() {
                    // Back to the earlier position..
                    ApexChat.animate(pureElement, backToOldCSS, {
                        easing,
                        duration: wiggleBounceAnimationDuration,
                        after() { }
                    });
                }
            });
        }
    }
}
